<homey-lotteries-dialog-content
  singleDescription="With your updated profile you were eligible for a new lottery, Homey's auto-apply feature submitted an application to that lottery."
  multipleDescription="With your updated profile you were eligible for new lotteries, Homey's auto-apply feature submitted applications to those lotteries."
  singleTitle="Auto-applied to a new lottery"
  multipleTitle="Auto-applied to new lotteries"
  [closeButton]="closeButton()"
  [notification]="data()"
>
  <ng-template lotteryDialogListItem let-lottery>
    <homey-open-lottery-list-item [noNegativeMargin]="true" [openInPopup]="true" [lottery]="lottery"></homey-open-lottery-list-item>
  </ng-template>
</homey-lotteries-dialog-content>
